angular.module(NgAppName).component('crCalloutBox', {
	templateUrl: 'crCalloutBox.html',
	// transclude: true,
	bindings: {
		currentType: '@',
		currentTypeCounter: '@',
        pageType: '@',
        offmarketImage: '@',
        newsletterImage: '@',
        newdevImage: '@',
        newlistingsImage: '@',
		conciergeImage: '@',
    	npCheckmarkImage: '@',
		isGuest: '@',
		name: '@',
		fname: '@',
		email: '@',
		phone: '@',
		usrId: '@',
		isMobile: '@',
		user: '<',
		newsletterSubscribeUrl: '@',
		newlistingsSubscribeUrl: '@',
		companyPhone: '@',
		newDevDealsAndOffMarketRpc: '@',
    	token: '@',
		trackCategory: '@',
		trackingActionBuilding: '@',
		gtag: '@',
		buildingToken: '@',
		listingToken: '@'
    },
	controller: ["patterns", "crResourcesService", "PubSub", function(patterns, crResourcesService, PubSub) {
		var ctrl = this;
		ctrl.patterns = patterns;
		ctrl.isGuest = parseInt(ctrl.isGuest, 10);
		ctrl.isMobile = parseInt(ctrl.isMobile, 10);
		ctrl.offMarketDealsType = 'off-market-deals';
        ctrl.signUpForNewsletterType = 'sign-up-for-newsletter';
        ctrl.newListingsType = 'new-listings';
        ctrl.newDevDealsType = 'new-dev-deals';
		ctrl.lastKeyPressed = null;
		ctrl.success = false;
		ctrl.isLoading = false;
		ctrl.emptyMessage = false;
		this.showDisclaimer = false;

        this.$onInit = () => {
        };

		this.resize = () => {
		};

		this.$onDestroy = () => {
		};

		this.submitLoggedUserNewsletter = function() {
			window.crRecaptcha.execute(() => { ctrl.submitLoggedUserNewsletterLogic(); }, "subscribe_to_newsletter");
		};

		// requires uuid because there can be multiple cr-subscribe instance on the same page
		this.uuid = Core.uuid();

		this.submitLoggedUserNewsletterLogic = function() {
			var postData = {
				email: ctrl.email,
				reCaptchaTokens: window.crRecaptcha.getTokens()
			};

			ctrl.isLoading = true;
			crResourcesService.post(ctrl.newsletterSubscribeUrl, postData).then(
				(data) => {
					ctrl.isLoading = false;
					if (data.RPCFormSubscribeToNewsletter_FORMSUMMARY && data.RPCFormSubscribeToNewsletter_FORMSUMMARY[0].status === true) {
						ctrl.success = true;
					} else {
						ctrl.success = false;
						if (data["RPCFormSubscribeToNewsletter_email"]) {
							var error = data["RPCFormSubscribeToNewsletter_email"];
							if (error[0].indexOf("valid") > 0) {
								this.form.email.$setValidity("pattern", false);
							} else {
								// may be another/generic message, but for now it's the same
								this.form.email.$setValidity("pattern", false);
							}
						}
					}
				},
				(error) => {
					ctrl.isLoading = false;
					ctrl.success = false;
				}
			).finally(() => {
				ctrl.isLoading = false;
				ctrl.success = true;
			});
		};

		this.fieldChange = function(key) {
			this.userEmailHasChanged = true;

			if (!this.form[key].$valid) {
				this.form[key].$setValidity(key + "Exist", true);
				this.form[key].$setValidity(key + "Short", true);
				this.form[key].$setValidity(key + "Global", true);
			}

			if (this.form.globalErrors && this.form.globalErrors.length > 0) {
				this.form.globalErrors = [];
			}
			this.form.needsValidation = true;
		};

		this.closePopupLoggedUserNewsletter = function() {
			PubSub.publish('cr-popup-close-popup-loggedusernewsletter');
		};

		this.submitLoggedUserNewlistings = function() {
			var postData = {
				email: ctrl.email,
				usrId: ctrl.usrId
			};
			ctrl.isLoading = true;
			crResourcesService.post(ctrl.newlistingsSubscribeUrl, postData).then(
				(data) => {
					ctrl.isLoading = false;
					ctrl.success = true;
				},
				(err) => {
					ctrl.isLoading = false;
					ctrl.success = false;
				}
			).finally(() => {
				ctrl.isLoading = false;
				ctrl.success = true;
			});
		};

		this.closePopupLoggedUserNewListings = function() {
			PubSub.publish('cr-popup-close-popup-loggedusernewlistings');
		};

		this.onKeyDown = function(e) {
			this.lastKeyPressed = e.keyCode;
		};

		this.submitLoggedUserOffMarketListings = function() {
			ctrl.isLoading = true;
			window.crRecaptcha.execute(() => {
				this.submitFormLogic();
			});
		};

		this.closePopupLoggedUserOffMarketListings = function() {
			PubSub.publish('cr-popup-close-popup-loggeduseroffmarketlistings');
		};

		this.submitLoggedUserNewDevDeals = function() {
			ctrl.isLoading = true;
			window.crRecaptcha.execute(() => {
				this.submitFormLogic();
			});
		};

		this.closePopupLoggedUserNewDevDeals = function() {
			PubSub.publish('cr-popup-close-popup-loggedusernewdevdeals');
		};

		this.submitFormLogic = function() {
			var url = ctrl.newDevDealsAndOffMarketRpc;
			var postData = this.createPostData();
			var crDataPromise = crResourcesService.post(url, postData);

			crDataPromise.then((data) => {
				if (data['RPCFormReusableContact_FORMSUMMARY'][0].status) {
					window.crRecaptcha.setSuccessState(true);

					ctrl.isLoading = false;
					ctrl.success = true;
					ctrl.successMessage = data['RPCFormReusableContact_FORMSUMMARY'][0].message;

					if (typeof data["RPCFormReusableContact_FORMSUMMARY"][0].token !== "undefined") {
						if (!!postData.msg) {
							ctrl.token = data["RPCFormReusableContact_FORMSUMMARY"][0].token;
							PubSub.publish("contact-form-propagate-token", ctrl.token);
						}
					}

					// track
					if (ctrl.trackCategory && ctrl.trackingActionBuilding) {
						crTrackerQueue.track({
							category: ctrl.trackCategory,
							action: ctrl.trackingActionBuilding,
							label: 'Contact Finish'
						});
					}

					// track gtag
					if (typeof(crGtag) !== 'undefined' && ctrl.gtag) {
						crGtag.track(ctrl.gtag);
					}

					if (typeof(crGtag) !== 'undefined' && data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign) {
						crGtag.track(data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.send_to, data.RPCFormReusableContact_FORMSUMMARY[0].adWordsCampaign.value);
					}

					if (!postData.msg) {
						ctrl.success = false;
						ctrl.successMessage = null;
						ctrl.emptyMessage = true;
					}
				} else {
					window.crRecaptcha.setSuccessState(false);

					if (this.form) {
						let specificError = false;
						if (data["RPCFormReusableContact_email"]) {
							var error = data["RPCFormReusableContact_email"];
							if (error[0].indexOf("valid") > 0) {
								this.form.email.$setValidity("pattern", false);
							} else {
								// may be another/generic message, but for now it's the same
								this.form.email.$setValidity("pattern", false);
							}
							specificError = true;
						}

						if (data["RPCFormReusableContact_dayphone"]) {
							var error = data["RPCFormReusableContact_dayphone"];
							if (error[0].indexOf("already exist") > 0 || error[0].indexOf("already in use") > 0 ) {
								this.form.phone.$setValidity("phoneExist", false);
							} else if (error[0].indexOf("too short") > 0) { // phone too short
								this.form.phone.$setValidity("phoneShort", false);
							} else { // twilio phone error
								this.form.phone.$setValidity("pattern", false);
							}
							specificError = true;
						}

						if (!this.form.globalErrors || !this.form.globalErrors.length) {
							this.form.globalErrors = [];
						}

						if (data["RPCFormReusableContact_recaptcha"]) {
							this.form.globalErrors.push('Recaptcha verification failed. Please try again.');
						} else if (!specificError) {
							this.form.globalErrors.push('Something went wrong. Please contact us for further assistance or try again later. (212) 755-5544.');
						}
					}
					ctrl.isLoading = false;
					ctrl.success = false;
				}
			}).finally(() => {
				ctrl.isLoading = false;
			});
		};

		this.createPostData = function() {
			var data = {
				name: ctrl.name,
				email: ctrl.email,
				dayphone: ctrl.phone,
				msg: (!!ctrl.message ? ctrl.message : ''),
				token: ctrl.token,
				popup: 'callout-' + ctrl.currentType, // callout-new-dev-deals | callout-off-market-deals
				source: ctrl.pageType,
				version: ctrl.currentType,
				doNotUseReCaptchaV2: 0,
				buildingToken: ctrl.buildingToken,
				listingToken: ctrl.listingToken,
				buyerRenter: 3
			};
			if (data.doNotUseReCaptchaV2 === 0) {
				data.reCaptchaTokens =  window.crRecaptcha.getTokens();
			}

			return data;
		};

		this.messageChange = function() {
			let trimmedMessage = ctrl.message.trim();
			if (!!trimmedMessage) {
				ctrl.emptyMessage = false;
			} else {
				ctrl.emptyMessage = true;
			}
		};
	}]
});